<template>
  <section class="py-6 py-md-7 container text-center" id="transactions">
    <h2>Explore Our Representative Transactions</h2>
    <div class="transaction-nav mt-5 mb-5 mb-md-6">
      <h4
        :class="[activeLink == 0 ? active : '', 'group-link']"
        @click="shuffleCards(0)"
      >
        Mergers &amp; Acquisitions
      </h4>
      <h4
        :class="[activeLink == 4 ? active : '', 'group-link']"
        @click="shuffleCards(4)"
      >
        Capital Raising
      </h4>
      <h4
        :class="[activeLink == 2 ? active : '', 'group-link']"
        @click="shuffleCards(2)"
      >
        Strategic Advisory &amp; Restructuring
      </h4>
    </div>
    <TransactionCardRow ref="cards" enableDarkMode showAllCards />
    <p class="mt-7 small-text">
      All securities related transactions are undertaken by our wholly-owned
      broker-dealer subsidiary CSCA Capital Advisors, LLC, a member of FINRA and
      SIPC.
    </p>
  </section>
</template>

<script>
import TransactionCardRow from "@/components/TransactionCardRow.vue";
export default {
  components: {
    TransactionCardRow
  },
  data() {
    return {
      activeLink: 0,
      active: "active-link"
    };
  },
  methods: {
    shuffleCards(target) {
      this.$refs.cards.setNewCards(target);
      this.activeLink = target;
    }
  }
};
</script>

<style lang="scss" scoped>
.transaction-nav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  border-bottom: 1px solid  #efefef;
}
.group-link {
  color:  #111d3c;
  font-size: 1.25rem;
  line-height: 2.25rem;
  padding-bottom: 1.75rem;
  margin-bottom: -1px;
  border-bottom: 1px solid  #efefef;
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.3s ease;
  &:hover,
  &.active-link {
    opacity: 1;
    border-bottom: 1px solid #dcb249;
    text-decoration: underline;
  }
  .small-text {
    font-size: 0.75rem;
  }
  @media screen and (max-width: 768px) {
    font-family: europa, sans-serif;
    font-weight: 400;
    text-decoration: none;
    font-size: 0.85rem;
    line-height: 1rem;
    text-transform: uppercase;
  }
}
</style>
